module.exports = __webpack_public_path__ + "img/vi.3b3def88.svg";